import React, { Suspense, useState, useEffect } from "react";
import { lazyWithRetry as lazy } from "@/utils/lazyWithRetry";
import { useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import Container from "@mui/material/Container";
import useMediaQuery from "@mui/material/useMediaQuery";
import { TopbarHeight } from "@/theme/Theme-variable";
import Cookie from "js-cookie";
import Loading from "../../Loading/Loading";
import Footer from "../partials/footer/Footer";
import Header from "../partials/header/Header";
import { BreadcrumbProvider } from "../partials/header/BreadcrumbContext";
import Sidebar from "../partials/sidebar/Sidebar";
import tokens from "@/theme/tokens";

const MainWrapper = styled("div")(() => {
  return {
    display: "flex",
    flexDirection: "column",
    minHeight: "100%",
    height: "100%",
    width: "100%",
  };
});

const isLoggedIn = !!Cookie.get("token");

const PageWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flex: "1 1 auto",
  [theme.breakpoints.down("md")]: {
    paddingBottom: isLoggedIn ? TopbarHeight : "0",
  },
}));

// Module scope, not the component body: a lazy component created during
// render is a new component type every render, so React unmounts the old
// subtree and re-runs the import each time.
const TellUs = lazy(() => import("@/components/SignupProcess/TellUs/TellUs"));

const MainLayout = ({ children }) => {
  const sideNav = useSelector((state) => state.sideNav);
  const [isSideNavOpen, setSideNavOpen] = useState(sideNav.get("menuOpen"));
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("md"));

  useEffect(() => {
    setSideNavOpen(sideNav.get("menuOpen"));
  }, [sideNav]);

  return (
    <>
      {/* Wraps Header and children together: the topbar is mounted once, above
          the routes, so a page reaches its breadcrumb slot through here. */}
      <BreadcrumbProvider>
        <MainWrapper>
          <Loading />
          <Sidebar />
          <Header
            sx={{
              paddingLeft: isSideNavOpen && lgUp ? tokens.space.px224 : "",
              top: { lg: 0, md: 0, sm: "auto", xs: "auto" },
              bottom: { lg: "auto", md: "auto", sm: 0, xs: 0 },
              zIndex: 10,
            }}
          />
          <PageWrapper>
            <Container
              maxWidth={false}
              sx={{
                paddingRight: tokens.space.sidebarOpenPaddingRight,
                paddingLeft: isSideNavOpen && lgUp ? tokens.space.sidebarOpenPaddingLeft : "",
              }}
            >
              {children}
              <Suspense fallback={<Loading />}>
                <TellUs />
              </Suspense>
            </Container>
          </PageWrapper>
        </MainWrapper>
      </BreadcrumbProvider>
      {!isLoggedIn && <Footer />}
    </>
  );
};
export default MainLayout;
